import { Breakpoint } from '@tmh-website/shared/const';
import styled, { css } from 'styled-components';

export interface ContainerProps {
  $numberOfColumns: Record<Breakpoint | number, number> | number;
  $gap?: number;
}

export const Container = styled.div<ContainerProps>`
  display: grid;
  gap: ${props => props.theme.gap.xSmall};
  ${props =>
    typeof props.$numberOfColumns === 'number' &&
    css`
      grid-template-columns: repeat(${props.$numberOfColumns}, 1fr);
    `}
  width: 100%;
  margin-bottom: ${props => props.theme.gap.xSmall};

  &:last-child {
    margin-bottom: 0;
  }

  ${props =>
    typeof props.$numberOfColumns === 'object' &&
    Object.keys(props.$numberOfColumns).map(
      breakpoint => css`
        @media (min-width: ${breakpoint}px) {
          grid-template-columns: repeat(${props.$numberOfColumns[breakpoint]}, 1fr);
        }
      `
    )}
`;
